import { offerSelector } from './offerData';
import { IState } from '../store';
import { getOfferType, isSuburban, isUrban } from '../utils/offer_type';

export const ROUTE_TAB_INDEX_B = 1;

export const ROUTE_TAB_INDEX_C = 3;

export const selectRouteMapTabPosition = (state: IState): number | undefined => {
  const offer = offerSelector(state);
  const offerType = getOfferType(offer);

  if (isSuburban(offerType)) {
    return ROUTE_TAB_INDEX_B;
  }

  if (isUrban(offerType)) {
    return ROUTE_TAB_INDEX_C;
  }

  return undefined;
};
